import { cn } from "@/shared/lib/utils"

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      // Sora-spec skeleton: opacity-based wash on the same single white token,
      // gentle pulse. No gradient shimmer (that's the "AI loading" tell Sora
      // explicitly avoids).
      className={cn("bg-foreground/[0.04] animate-pulse rounded-md", className)}
      {...props}
    />
  )
}

export { Skeleton }
